export const customerLinks = [
    {
        name: "My Orders",
        link: "/customer/orders",
        img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/orders-active.svg",
        img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/orders.svg",
    },
    {
        name: "Recipes & My Menu",
        link: "/customer/lists",
        img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/my-recipies-active.svg",
        img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/my-recipies.svg",
    },
    // {
    //     name: "Messages",
    //     link: "/",
    //     img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/email-active.svg",
    //     img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/email.svg",
    // },
    // {
    //     name: "Coupons and discounts",
    //     link: "/customer/coupons",
    //     img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/coupons-and-discounts-active.svg",
    //     img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/coupons-and-discounts.svg",
    // },
    // {
    //     name: "Desi Family Member",
    //     link: "/customer/my-desi-family",
    //     img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/credit-card-active.svg",
    //     img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/credit-card.svg",
    //     badges: [
    //         "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/silver-badge.svg",
    //         "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/golden-badge.svg",
    //     ],
    // },
    {
        name: "Returns and complaints",
        link: "/customer/return-refunds",
        img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/return-policy-active.svg",
        img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/return-policy.svg",
    },
    {
        name: "Data and payment",
        link: "/customer/data-payment",
        img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/data-payment-active.svg",
        img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/data-payment.svg",
    },
    // {
    //     name: "Invite a friend",
    //     link: "/customer/invite-friend",
    //     img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/invite-friend-active.svg",
    //     img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/invite-friend.svg",
    // },
    {
        name: "Customer service",
        link: "/customer/customer-service",
        img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/customer-support-active.svg",
        img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/customer-support.svg",
    },
    {
        name: "Account settings",
        link: "/customer/account",
        img_active: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/setting-active.svg",
        img_inactive: "https://desi-fresh.b-cdn.net/components_static/sidebar_icons/setting.svg",
    },
];
